module.exports = __webpack_public_path__ + "static/media/IconRedeEnergia.60a5c110.svg";